import _padStart from 'lodash/padStart';

/**
 * The Trqk eventbridge log events are stored in S3 under a key that begins with a timestamp
 * consisting of a 14-character string of numbers, formatted as: YYYYYMMDD_HHMMSS
 * If necessary, leading zeroes are added to keep the length consistent. Times are in UTC.
 * This function takes a Date instance and converts it into such a timestamp.
 * @param {Date} date a JavaScript Date instance
 * @returns {string} a 14-character UTC timestamp formatted as YYYYYMMDD_HHMMSS
 */
export const getLogDate = (date: Date): string => {
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth() + 1; // month is 0-indexed
    const day = date.getUTCDate();
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const seconds = date.getUTCSeconds();

    const monthPadded = _padStart(month.toString(), 2, '0');
    const dayPadded = _padStart(day.toString(), 2, '0');
    const hoursPadded = _padStart(hours.toString(), 2, '0');
    const minutesPadded = _padStart(minutes.toString(), 2, '0');
    const secondsPadded = _padStart(seconds.toString(), 2, '0');

    return `${year}${monthPadded}${dayPadded}_${hoursPadded}${minutesPadded}${secondsPadded}`;
};
